#wrapper {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-top: var(--spacer);
}

.title {
  margin-top: calc(var(--spacer) * 1.5);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

.text-form-field-section {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-items: start;
}

.subform-section {
  display: flex;
  flex-direction: column;

  .subform-section-label {
    flex: 1;

    &:after {
      content: ':';
    }
  }

  .subform-section-fields {
    flex: 1;
  }
}

.toggle-field {
  --label-width: 450px;
  --form-field-max-width: 400px;
}

.toggle-field-indented {
  --label-width: 385px;
  --form-field-max-width: 400px;
}

#basic-monthly-product-details-text {
  max-width: 650px;
}

//temporary fix (FED-1933)
gz-form-field-toggleable {
  &::part(input-wrapper) {
    width: auto;
  }
}
